import { Delta } from "@/features/Metrics/Delta";
import { Metric } from "@/entities/Finance/Finance.model";
import { HydratedMetric } from "@/features/Metrics/HydratedMetric";
import { SelectedCell } from "@/utilityTypes/grids.types";
import { Period } from "@/features/Metrics/Period";
import type { EmptyMetricPanelProps } from "../EmptyMetricPanel";
import { EvaluatedCtxLineagePanelProps } from "../EvaluatedCtxLineagePanel";

export enum AIMViewType {
    EVALUATED_CTX_LINEAGE = "EVALUATED_CTX_LINEAGE",
    DELTA_LINEAGE = "DELTA_LINEAGE",
    LABS_LINEAGE = "LABS_LINEAGE",
    DATA_SOURCES_SETTINGS = "DATA_SOURCES_SETTINGS",
    INVESTMENT_CRITERIA = "INVESTMENT_CRITERIA",
    METRIC_LINEAGE = "METRIC_LINEAGE",
    LTM_LINEAGE = "LTM_LINEAGE",
    EMPTY_METRIC = "EMPTY_METRIC",
}

export type AIMContextView =
    | {
          type: AIMViewType.DELTA_LINEAGE;
          props: {
              delta: Delta;
          };
          isExpanded?: boolean;
          selectedCell?: SelectedCell;
      }
    | {
          type: AIMViewType.LTM_LINEAGE;
          props: {
              metric: HydratedMetric | null;
          };
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.METRIC_LINEAGE;
          props: {
              metric: HydratedMetric | null;
              title?: string;
              period: Period;
          };
          isExpanded?: boolean;
          selectedCell?: SelectedCell;
      }
    | {
          type: AIMViewType.LABS_LINEAGE;
          metric: Metric | undefined | null;
          title: string;
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.DATA_SOURCES_SETTINGS;
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.INVESTMENT_CRITERIA;
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.EVALUATED_CTX_LINEAGE;
          props: EvaluatedCtxLineagePanelProps;
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.EMPTY_METRIC;
          props: EmptyMetricPanelProps;
          isExpanded?: boolean;
          selectedCell?: SelectedCell;
      };
